import { render } from "./klb-header.vue?vue&type=template&id=19d5ba1c&scoped=true"
import script from "./klb-header.vue?vue&type=script&lang=js"
export * from "./klb-header.vue?vue&type=script&lang=js"

import "./klb-header.vue?vue&type=style&index=0&id=19d5ba1c&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d5ba1c"]])

export default __exports__